import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { createInjectable } from 'ngxtension/create-injectable';
import type { UserAgreementPatchBody, UsersUpdateResponseType } from '@tig-dpqa-cloud/contract-backend-frontend';

export const UserAgreementsApiService = createInjectable(
  () => {
    const http = inject(HttpClient);

    return {
      patchUserAgreements: (body: UserAgreementPatchBody) =>
        http.patch<UsersUpdateResponseType>(
          '/api/user/agreements',
          body,
        ),
    };
  },
  { providedIn: 'root' },
);
